'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import amigo_gen from 'amigo2-instance-data';
import FaCaretUp from 'react-icons/lib/fa/caret-up';
import FaCaretRight from 'react-icons/lib/fa/caret-right';

var AssociationEvidence = function (_Component) {
  _inherits(AssociationEvidence, _Component);

  function AssociationEvidence() {
    _classCallCheck(this, AssociationEvidence);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {
      expanded_withs: [],
      expanded_refs: []
    };
    _this.linker = new amigo_gen().linker;
    _this.renderECOgroup = _this.renderECOgroup.bind(_this);
    _this.renderECOgroups = _this.renderECOgroups.bind(_this);
    _this.renderEvidenceRow = _this.renderEvidenceRow.bind(_this);
    _this.onExpandCollapseWith = _this.onExpandCollapseWith.bind(_this);
    _this.onExpandCollapseRef = _this.onExpandCollapseRef.bind(_this);

    _this.rollupWithIndex = 3;
    _this.rollupRefIndex = 3;
    return _this;
  }

  AssociationEvidence.prototype.onExpandCollapseWith = function onExpandCollapseWith(with_list) {
    var self = this;
    var expanded_withs = this.state.expanded_withs;
    var index = expanded_withs.indexOf(with_list);
    if (index >= 0) {
      expanded_withs.splice(index, 1);
    } else {
      expanded_withs.push(with_list);
    }
    self.setState({
      expanded_withs: expanded_withs
    });
  };

  AssociationEvidence.prototype.onExpandCollapseRef = function onExpandCollapseRef(ref_list) {
    var self = this;
    var expanded_refs = this.state.expanded_refs;
    var index = expanded_refs.indexOf(ref_list);
    if (index >= 0) {
      expanded_refs.splice(index, 1);
    } else {
      expanded_refs.push(ref_list);
    }
    self.setState({
      expanded_refs: expanded_refs
    });
  };

  AssociationEvidence.prototype.isWithExpanded = function isWithExpanded(with_list) {
    return this.state.expanded_withs.indexOf(with_list) >= 0;
  };

  AssociationEvidence.prototype.isRefExpanded = function isRefExpanded(ref_list) {
    return this.state.expanded_refs.indexOf(ref_list) >= 0;
  };

  AssociationEvidence.prototype.renderWiths = function renderWiths(eco_group, base_key) {
    var _this2 = this;

    var with_set = [];
    if (eco_group.evidence_with.length === 0) {
      with_set.push(React.createElement('div', { className: 'ontology-ribbon__content', key: base_key + '.nowiths' }));
    } else {
      var with_max = eco_group.evidence_with.length - 1;
      eco_group.evidence_with.forEach(function (with_id, w_index) {
        var suffix = w_index < with_max ? ', ' : '';
        var link = with_id.startsWith('MGI:MGI:') ? with_id.substr(4) : with_id;
        var url;

        if (with_id.match(/^(WB:WBVar).*/)) {
          url = 'http://www.wormbase.org/get?name=' + with_id.split(':')[1] + '&class=Variation';
        } else {
          url = _this2.linker.url(with_id);
        }

        if (with_max <= _this2.rollupWithIndex || w_index < _this2.rollupWithIndex || _this2.isWithExpanded(eco_group.evidence_with) && w_index < with_max) {
          with_set.push(React.createElement(
            'div',
            { className: 'ontology-ribbon__content', key: base_key + '.' + w_index + '.with' },
            React.createElement(
              'a',
              { className: 'link', href: url, target: '_blank' },
              link,
              suffix
            )
          ));
        } else if (w_index === with_max && _this2.isWithExpanded(eco_group.evidence_with)) {
          suffix = ' ';
          with_set.push(React.createElement(
            'div',
            { className: 'ontology-ribbon__content', key: base_key + '.' + w_index + '.with' },
            React.createElement(
              'a',
              { className: 'link', href: url, target: '_blank', onClick: function onClick() {
                  _this2.onExpandCollapseWith(eco_group.evidence_with);
                } },
              link
            ),
            suffix,
            React.createElement(FaCaretUp, { className: 'bright link', onClick: function onClick() {
                _this2.onExpandCollapseWith(eco_group.evidence_with);
              } })
          ));
        } else if (w_index === _this2.rollupWithIndex && !_this2.isWithExpanded(eco_group.evidence_with)) {
          suffix = ' ... ';
          with_set.push(React.createElement(
            'div',
            { className: 'ontology-ribbon__content', key: base_key + '.' + w_index + '.with' },
            React.createElement(
              'a',
              { className: 'link', href: url, target: '_blank' },
              ' ',
              link,
              ' '
            ),
            '\xA0',
            React.createElement(
              'a',
              { className: 'link', target: '_blank', onClick: function onClick() {
                  _this2.onExpandCollapseWith(eco_group.evidence_with);
                } },
              suffix,
              React.createElement(FaCaretRight, { className: 'bright link' })
            )
          ));
        }
      });
    }
    return with_set;
  };

  AssociationEvidence.prototype.renderReferences = function renderReferences(eco_group, base_key) {
    var _this3 = this;

    var ref_set = [];
    var ref_max = eco_group.evidence_refs.length - 1;

    eco_group.evidence_refs.forEach(function (ref, r_index) {
      var url = _this3.linker.url(ref);
      var suffix = r_index < ref_max ? ', ' : '';
      if (ref_max <= _this3.rollupRefIndex || r_index < _this3.rollupRefIndex || _this3.isRefExpanded(eco_group.evidence_refs) && r_index < ref_max) {
        ref_set.push(React.createElement(
          'div',
          { className: 'ontology-ribbon__content', key: base_key + '.' + r_index + '.ref' },
          React.createElement(
            'a',
            { className: 'link', href: url, target: '_blank' },
            ref,
            suffix
          )
        ));
      } else if (r_index === ref_max && _this3.isRefExpanded(eco_group.evidence_refs)) {
        suffix = ' ';
        ref_set.push(React.createElement(
          'div',
          { className: 'ontology-ribbon__content', key: base_key + '.' + r_index + '.ref' },
          React.createElement(
            'a',
            { className: 'link', href: url, target: '_blank', onClick: function onClick() {
                _this3.onExpandCollapseRef(eco_group.evidence_refs);
              } },
            ref
          ),
          suffix,
          React.createElement(FaCaretUp, { className: 'bright link', onClick: function onClick() {
              _this3.onExpandCollapseRef(eco_group.evidence_refs);
            } })
        ));
      } else if (r_index === _this3.rollupRefIndex && !_this3.isRefExpanded(eco_group.evidence_refs)) {
        suffix = ' ... ';
        ref_set.push(React.createElement(
          'div',
          { className: 'ontology-ribbon__content', key: base_key + '.' + r_index + '.ref' },
          React.createElement(
            'a',
            { className: 'link', href: url, target: '_blank' },
            ' ',
            ref,
            ' '
          ),
          '\xA0',
          React.createElement(
            'a',
            { className: 'link', target: '_blank', onClick: function onClick() {
                _this3.onExpandCollapseRef(eco_group.evidence_refs);
              } },
            suffix,
            React.createElement(FaCaretRight, { className: 'bright link' })
          )
        ));
      }
    });
    return ref_set;
  };

  AssociationEvidence.prototype.renderECOgroup = function renderECOgroup(eco_group, row, eco_index, group_index) {
    var base_key = row + '.' + eco_index + '.' + group_index;

    return React.createElement(
      'div',
      { className: 'ontology-ribbon__eco-group-row', key: base_key + '.grouprow' },
      React.createElement(
        'div',
        { className: 'ontology-ribbon__with-column', key: base_key + '.withs' },
        this.renderWiths(eco_group, base_key)
      ),
      React.createElement(
        'div',
        { className: 'ontology-ribbon__ref-column', key: base_key + 'refs' },
        this.renderReferences(eco_group, base_key)
      )
    );
  };

  AssociationEvidence.prototype.renderECOgroups = function renderECOgroups(eco_groups, row, eco_index) {
    var _this4 = this;

    var evi_row = [];
    eco_groups.forEach(function (eco_group, group_index) {
      evi_row.push(_this4.renderECOgroup(eco_group, row, eco_index, group_index));
    });
    return evi_row;
  };

  AssociationEvidence.prototype.renderQualifier = function renderQualifier(e_group, row, eco_index, group_index) {
    var quals = [];
    var q_set = e_group.evidence_qualifier;
    if (q_set !== undefined) {
      var qual_max = q_set.length - 1;
      q_set.forEach(function (q, index) {
        var url = "http://geneontology.org/docs/go-annotations/";
        switch (q) {
          case "contributes_to":
            url += "#the-contributes-to-qualifier";
            break;
          case "colocalizes_with":
            url += "#the-colocalizes-with-qualifier";
            break;
          default:
            url += "#annotation-qualifiers";

        }
        // we exclude the NOT qualifier as it is handled separately
        var suffix = index < qual_max ? ', ' : '';
        if (q !== 'not') {
          quals.push(React.createElement(
            'a',
            {
              className: 'evidence-qualifier',
              href: url,
              key: 'q' + row + eco_index + group_index + index,
              rel: 'noopener noreferrer',
              target: '_blank',
              title: q
            },
            q,
            suffix
          ));
        }
      });
    }
    return quals;
  };

  AssociationEvidence.prototype.renderQualifiers = function renderQualifiers(eco_groups, row, eco_index) {
    var _this5 = this;

    var quals = [];
    var base_key = row + '.' + eco_index + '.';
    eco_groups.forEach(function (e_group, group_index) {
      quals.push(React.createElement(
        'div',
        { key: base_key + group_index },
        _this5.renderQualifier(e_group, row, eco_index, group_index)
      ));
    });
    return quals;
  };
  /*
    Key is one particular ECO code and there may be more than one set of
    evidence for that particular ECO code
  */


  AssociationEvidence.prototype.renderEvidenceRow = function renderEvidenceRow(eco_groups, row, eco_index) {
    var eco = eco_groups[0].evidence_type;
    var eco_id = eco_groups[0].evidence_id;
    var eco_label = eco_groups[0].evidence_label;

    if (this.props.filters.get(eco)) {
      return React.createElement(
        'div',
        { className: 'ontology-ribbon__evidence-row', key: row + '.' + eco_index },
        React.createElement(
          'div',
          { className: 'ontology-ribbon__eco' },
          React.createElement(
            'div',
            null,
            React.createElement(
              'a',
              {
                className: 'link',
                href: 'http://www.evidenceontology.org/term/' + eco_id,
                key: row + '.' + eco_index + '.' + eco_id,
                title: eco_label,
                target: '_blank'
              },
              eco
            )
          ),
          this.renderQualifiers(eco_groups, row, eco_index)
        ),
        React.createElement(
          'div',
          { className: 'ontology-ribbon__eco-group-column', key: row + '.' + eco_index + '.groups' },
          this.renderECOgroups(eco_groups, row, eco_index)
        )
      );
    } else {
      return null;
    }
  };

  /*
    For each association there are multiple types of evidence, each type (ECO code) gets a row
  */


  AssociationEvidence.prototype.render = function render() {
    var _this6 = this;

    var _props = this.props,
        assoc = _props.assoc,
        row = _props.row;

    var e_map = assoc.evidence_map;
    var eco_elements = [];

    e_map.forEach(function (eco_groups, eco_index) {
      eco_elements.push(_this6.renderEvidenceRow(eco_groups, row, eco_index));
    });
    return eco_elements;
  };

  return AssociationEvidence;
}(Component);

AssociationEvidence.propTypes = process.env.NODE_ENV !== "production" ? {
  assoc: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  row: PropTypes.number
} : {};

export default AssociationEvidence;